import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import XIcon from '@/components/XIcon/Index.vue'
import '@/assets/index.css'
import '@/styles/index.scss'
import util from './utils'
import cloudbase from '@cloudbase/js-sdk'
import Video from 'video.js'
import 'video.js/dist/video-js.min.css'

// video
Vue.prototype.$video = Video
Vue.prototype.$util = util
Vue.prototype.$app = cloudbase.init({
  env: 'cloud-yaopaih5-7gn23roq548272d1'
})
// 全局注册Icon组件
Vue.component('Icon', XIcon)
Vue.use(ElementUI)
Vue.config.productionTip = false

const isSupportWebp = () => {
  try {
    return (
      document
        .createElement('canvas')
        .toDataURL('image/webp', 0.5)
        .indexOf('data:image/webp') === 0
    )
  } catch (err) {
    return false
  }
}
// 判断webp兼容度
Vue.prototype.$pic_type = isSupportWebp() ? 'webp' : 'png'

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
